export class Generate2FAReturnModel {
    path: string | null = null;
    code: string | null = null;
}
